var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import React, { Component, Fragment } from "react";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin, withAITracking } from "@microsoft/applicationinsights-react-js";
import { createBrowserHistory } from "history";
import { AppInsights, Events } from ".";
import { ApplicationNames, ComponentNames, InstrumentationKeys } from "./Constants";
var reactPlugin = new ReactPlugin(); // NOTE: the package '@microsoft/applicationinsights-react-js' has a HOC withAITracking that requires this to be a Class Component rather than a Functional Component

var TelemetryProviderBase =
/** @class */
function (_super) {
  __extends(TelemetryProviderBase, _super);

  function TelemetryProviderBase(props) {
    var _this = this;

    if (props.application && props.component || props.title && props.instrumentationKey) {
      _this = _super.call(this, props) || this;
      _this.state = {
        initialized: false
      };
    } else {
      throw new Error("Set either Application and Component -or- Title and InstrumentationKey");
    }

    return _this;
  }
  /**
   * Create the App Insights Telemetry Service
   * @param {string} instrumentationKey - Application Insights Instrumentation Key
   * @param {Object} browserHistory - client's browser history, supplied by the withRouter HOC
   */


  TelemetryProviderBase.createTelemetryService = function (instrumentationKey, id, title, enableAPITracking) {
    var _a;

    try {
      var history_1 = createBrowserHistory();
      var applicationInsights = new ApplicationInsights({
        config: {
          instrumentationKey: instrumentationKey,
          maxBatchInterval: 0,
          disableFetchTracking: !(enableAPITracking === true),
          disableAjaxTracking: !(enableAPITracking === true),
          extensions: [reactPlugin],
          extensionConfig: (_a = {}, _a[reactPlugin.identifier] = {
            history: history_1
          }, _a)
        }
      });
      applicationInsights.loadAppInsights();
      var appInsights = new AppInsights(applicationInsights, instrumentationKey, id, title);
      appInsights.track(Events.Initialization);
      return appInsights;
    } catch (error) {
      // Failed to initialize app insights; do nothing
      console.warn("Failed to initialize App Insights", error);
    }

    return undefined;
  };

  TelemetryProviderBase.prototype.componentDidMount = function () {
    var appInsights = undefined;

    if (this.props.application && this.props.component) {
      appInsights = TelemetryProviderBase.GetInstance(this.props.application, this.props.component, this.props.enableAPITracking || false);
      if (this.props.after) this.props.after(appInsights);
    } else if (this.props.componentId && this.props.title && this.props.instrumentationKey) {
      appInsights = TelemetryProviderBase.GetInstanceByName(this.props.componentId, this.props.instrumentationKey, this.props.title, this.props.enableAPITracking || false);
      if (this.props.after) this.props.after(appInsights);
    } else {
      // Shouldn't happen; checked in constructor but clients may update props after mount which will break things
      throw new Error("Set either Application and Component -or- Title and InstrumentationKey");
    }

    this.setState({
      initialized: true
    });
  };
  /**
   *
   * @param id Used for identifying the correct AppInsights
   * @param instrumentationKey  Used for registering against Azure App Insights
   * @param title Used for event metrics
   * @param enableAPITracking When true all API calls will be tracked
   * @returns
   */


  TelemetryProviderBase.GetInstanceByName = function (id, instrumentationKey, title, enableAPITracking) {
    try {
      var item = TelemetryProviderBase.telemetryProviders.find(function (t) {
        return t.id === title && t.key === instrumentationKey;
      });
      if (item) return item;
      var appInsights = TelemetryProviderBase.createTelemetryService(instrumentationKey, id, title, enableAPITracking);
      if (appInsights) TelemetryProviderBase.telemetryProviders.push(appInsights);
      return appInsights;
    } catch (_a) {}

    return undefined;
  };
  /**
   *
   * @param application Application to track
   * @param component Component to track
   * @param enableAPITracking When true all API calls will be tracked
   * @returns
   */


  TelemetryProviderBase.GetInstance = function (application, component, enableAPITracking) {
    var id = application + "-" + component;
    var key = InstrumentationKeys[application];
    var applicationName = ApplicationNames[application];
    var componentName = ComponentNames[component];
    if (componentName) componentName = " - " + componentName;
    var title = applicationName + componentName;
    return this.GetInstanceByName(id, key, title, enableAPITracking);
  };

  TelemetryProviderBase.prototype.render = function () {
    var children = this.props.children;
    return React.createElement(Fragment, null, children);
  };

  TelemetryProviderBase.telemetryProviders = [];
  return TelemetryProviderBase;
}(Component);

export { TelemetryProviderBase };
export var TelemetryProvider = withAITracking(reactPlugin, TelemetryProviderBase);